import React, { useState } from "react";
import { useLocation } from "react-router";
import { Ptag } from "components/core";
import { ActivateButton, HeaderBarView } from "./styles";
import ProfilePopper from "./ProfilePopper";
import { MENU_ITEMS } from "constants";
import { PATHNAME_MAPPING } from "constants";
import http from "services/httpService";
import useUser from "hooks/useUser";
import { planSetupInProgress, planSetupPendingInProgress } from "utlis/utils";
import useFetchCompany from "pages/v1/Overview/useFetchCompany";

function HeaderBar() {
  const [localPremission, setLocalPermission] = useState(true);
  const { pathname } = useLocation();
  const { getPermission } = useUser();
  const { company } = useFetchCompany();
  const permission = getPermission();

  const fetchCompNameFromLS = () => {
    try {
      let productsData = JSON.parse(
        localStorage.getItem("products_with_permissions")
      );
      return productsData;
    } catch (error) {
      return company.company_name;
    }
  };

  const customHeader = () => {
    try {
      let productsData = fetchCompNameFromLS();
      if (productsData === null) {
        const { data } = http.get("/business/get_company_product_details/");
        return data.company_name;
      }
      return productsData.company_name;
    } catch (error) {
      return "Dashboard";
    }
  };

  const getPathnameText = (pathname) => {
    if (PATHNAME_MAPPING[pathname]) {
      return PATHNAME_MAPPING[pathname];
    }

    for (const key in PATHNAME_MAPPING) {
      if (key.includes("*")) {
        const basePath = key.replace("/*", "");
        if (pathname.startsWith(basePath)) {
          return PATHNAME_MAPPING[key];
        }
      }
    }

    return "";
  };

  const pageTitle = MENU_ITEMS.find(
    (item) => item.path === pathname
  )?.headerName;

  const activatePlan = async () => {
    try {
      const { data } = await http.post("/business/activate_company/");
      setLocalPermission(false);
    } catch (e) {
      console.log(e);
    }
  };

  function isV1Path(pathname) {
    // 1. Remove trailing slashes
    const cleanPath = pathname.replace(/\/+$/, "");

    // 2. Check if the string exists inside the array
    return ["/v1", "/v1/overview"].includes(cleanPath);
  }
  const displayProfilePopper = () => {
    if (planSetupPendingInProgress() || planSetupInProgress()) {
      return;
    }
    return <ProfilePopper />;
  };

  return (
    <HeaderBarView>
      <Ptag fontWeight="600" fontSize="32px" fontFamily="Merriweather">
        {isV1Path(pathname)
          ? customHeader()
          : getPathnameText(pathname) || pageTitle}
      </Ptag>
      <aside>
        {permission?.allow == "APPROVE" &&
          !permission?.isApproved &&
          localPremission && (
            <ActivateButton onClick={activatePlan}>Activate</ActivateButton>
          )}
        {displayProfilePopper()}
      </aside>
    </HeaderBarView>
  );
}

export default HeaderBar;
